<template>
  <div class="main_contract_edit">
    <div class="content">
      <div class="list_p" v-html="get_word(`create_contract_parts_${type === 'settings' ? '1' : '2'}`)"></div>
      <div class="contracts_container" ref="contractsList">
        <loader v-if="isLoading"  />
        <template v-for="(part, i) in partsComp" :key="part.id">
          <div class="contract-part-wrapper">
            <div class="drag-handle"></div>
            <contractPart 
              @update="part = $event" 
              @save="saveContract()" 
              @addClause="addClause($event, part.id)" 
              @addPart="addPart($event)" 
              :partComp="part"  
              :index="i"
            />
          </div>
        </template>
        <div class="btn_b fit text_s" @click="addPart()">הוספת פרק</div>
      </div>
      <div class="btn_container">
        <div class="btn" @click="saveContract(true);">המשך לשלב הבא</div>
      </div>
    </div>
  </div>
</template>

<script>
import Sortable from 'sortablejs';
import contractPart from './contractPart.vue';
import Loader from '../Loader.vue';
 
export default {
  props: {
    edit_token: {
      type: String,
      required: true,
    },
    contractType: {
      type: Object,
      required: true,
    }
  },
  components: {contractPart, Loader},
  data() {
    return {
      expntionBoxs: [],
      contract: null,
      sortable: null,
      isLoading: false
    }
  },
  mounted() {
    // alert('הפרקים ניתנים לסידור והוספה על ידי גרירה ושחרור');
    // this.init();
    this.$nextTick(() => {
      setTimeout(() => {
        this.initSortable();
      }, 1000);
    });
  },
  unmounted() {
    if (this.sortable) {
      this.sortable.destroy();
    }
  },
  computed: {
    partsComp() {
      const res = this.contractType?.parts ? this.filtereParts(this.contractType.parts) : [];
      return res;
    }
  },
  methods: {
    pushPart(parts, part) {
      parts.forEach(subPart => {
        if (subPart.id === part.pid) {
          subPart.isOpen = true;
          subPart.parts.push(part);
         
          return true;
        }
        if (subPart.parts) {
          this.pushPart(subPart.parts, part);
          return this.toast('הפרק נוסף בהצלחה');
        }
      });
      return false;
    },
    addPart(part_id=null) {
      this.api({ action: 'contracts/add_part', data: {contract_id: this.contractType.contract_id, pid: part_id, type_id: this.contractType.id}}, (data) => {
          if (data.data) {
            if (data.data.pid) {
              this.pushPart(this.contractType.parts, data.data);
            } else {
              this.contractType.parts.push(data.data);
            }
          }
      });
    },
    initSortable() {
      const el = this.$refs.contractsList;
      if (!el) return;

      if (this.sortable) {
        this.sortable.destroy();
      }

      this.sortable = Sortable.create(el, {
        animation: 150,
        ghostClass: 'sortable-ghost',
        dragClass: 'sortable-drag',
        handle: '.drag-handle',
        direction: 'vertical',
        scroll: true,
        scrollSensitivity: 30,
        scrollSpeed: 10,
        onEnd: (evt) => {
          const { oldIndex, newIndex } = evt;
          if (oldIndex === newIndex) return;

          // Update the parts array order
          const parts = this.contractType.parts;
          const part = parts.splice(oldIndex, 1)[0];
          parts.splice(newIndex, 0, part);

          // Update ord values for all parts
          parts.forEach((part, index) => {
            part.ord = index + 1;
          });

          // Save the new order
          this.saveContract(false);
        }
      });
    },
    saveContract(next=false) {
      this.api({ action: 'contracts/save', data: {token: this.edit_token, contract_type: this.contractType}}, (data) => {
          if(data.data && data.data.length > 0)
          {
            this.updatePartsAndClausesRecursively(this.contractType.parts, data.data);
          }
          if (next) this.$emit('next');
      });
    },
    updatePartsAndClausesRecursively(parts, newData) {
      if (!parts) return;
      
      parts.forEach(part => {
        // Update clauses in current part
        if (part && part.clauses && part.clauses.length > 0) {
          part.clauses.forEach(clause => {
            const matchingData = newData.find(d => d.id === clause.id);
            if (matchingData) {
              clause.id = matchingData.new_id;
              clause.new = false;
            }
          });
        }
        
        // Recursively process nested parts
        if (part.parts && part.parts.length > 0) {
          this.updatePartsAndClausesRecursively(part.parts, newData);
        }
      });
    },
    autoSave() {
      this.saveContract(false);
    },

    toggleBox(boxName) {
        if (this.expntionBoxs.includes(boxName)) this.expntionBoxs = this.expntionBoxs.filter( str => str != boxName)
        else this.expntionBoxs.push(boxName)
    },
    init() {
      // this.api({ action: 'contracts/results', data: {token: this.edit_token , type_id: this.type_id}}, (data) => {
      //   this.contract = data.data;
      //   this.contractType.parts = this.contractType.parts.map(part => ({
      //     ...part,
      //     clauses: part.clauses.map(clause => ({
      //       ...clause,
      //       edit_mode: false,
      //       content_temp: clause.content
      //     }))
      //   }));
      //   this.isLoading = true;
      // });
    },
    addClause(contentClause, partId) {
      for (let i = 0; i < this.contractType.parts.length; i++) {
        if (this.contractType.parts[i].id === partId) {
          this.contractType.parts[i].clauses.push({id: this.uniqueId(), content: contentClause, content_temp: contentClause, edit_mode: false, pid: partId })
        }
      }
    }
  }
}
</script>

<style lang="scss">
.main_contract_edit {
  >.content {  
    &{display: flex;  flex-direction: column;  gap: var(--gap_xmid);}
    .btn_container { align-self: flex-end;}
  }
  .contracts_container { 
    &{display: flex; flex-direction: column;  gap: var(--gap);}

    .contract-part-wrapper {
      position: relative;
      
      &::before { content: ''; position: absolute; inset: 0; border-radius: 8px; pointer-events: none; transition: box-shadow 0.2s ease;}

      .drag-handle { position: absolute; right: -12px; top: 50%; transform: translateY(-50%); width: 20px; height: 35px; background: var(--dark_blue); border-radius: 12px; display: flex; align-items: center; justify-content: center; cursor: grab; opacity: 0; transition: opacity 0.2s ease; color: white; z-index: 10;

        &:hover { opacity: 1;}

        &:active { cursor: grabbing;}

        &::before { content: '⋮⋮'; text-orientation: mixed; font-size: 15px; line-height: 1; }
      }

      &:hover {
        .drag-handle { opacity: 0.6;}
      }
    }
  }

  // Sortable classes
  .sortable-ghost { 
    &{opacity: 0.3; background: var(--pageBG);}

    &::before { box-shadow: inset 0 0 0 2px var(--dark_blue);}
  }

  .sortable-drag { 
    &{background: white; box-shadow: 0 4px 16px rgba(0,0,0,0.1);}
    
    .drag-handle { opacity: 1;}
  }

  .sortable-chosen {
    .drag-handle { opacity: 1;}
  }
}
</style>